var render = function (_h,_vm) {var _c=_vm._c;return _c('button',{class:{ 'nav_slider-item': true,  btn: true,  'is-active': _vm.props.isActive },on:{"click":function () { return _vm.parent.$listeners.itemClick && _vm.parent.$listeners.itemClick(_vm.props); }}},[_vm._v("\n    "+_vm._s(_vm.props.label)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-feee65f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/mobile/components/NavSlider/NavSliderItem.vue
// module id = 1244
// module chunks = 0